export const FileNames = Object.freeze({
    GGC_SUPPORT: "GGC Support",
    VISUALIZATIONS: "Visualizations"
})